import Notes from "@/components/notes";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface WikiPageThreadProps {
	page: Pick<Tables<"wikiPages">, "id" | "orgId">;
}

/**
 * The thread beside a page, the same whether the page is read or edited: an author often opens
 * the editor because of a comment, and the comment should still be there while they act on it.
 * It reads and writes through the notes domain like every other comment surface; the parent row
 * lets the client ask the Wiki rule before it shows a form whose submit would be a 403.
 */
export function WikiPageThread({ page }: WikiPageThreadProps) {
	/** Render */
	return (
		<Notes
			notesTable="wikiPageNotes"
			identifier={page.id}
			parent={{ id: page.id, orgId: page.orgId }}
			className="h-full rounded-l-none"
			// Beside a page the panel is the aside's full height, so the thread takes the space
			// the form leaves rather than the component's own 400px cap.
			contentClassName="h-full rounded-bl-none [&>*:first-child]:min-h-0 [&>*:first-child]:flex-1 [&>*:first-child]:max-h-none"
		/>
	);
}
